<template>
  <div v-if="fieldChangeHistory.length">
    <v-tooltip top max-width="300px">
      <template v-slot:activator="{ on, attrs }">
        <v-avatar v-bind="attrs" size="7" color="secondary" class="ml-1" v-on="on" />
      </template>
      <div id="order-change-history-tooltip">
        <p>{{ $t(`views.dashboardDetail.coreOrders.coreOrdersTable.changeHistory.${field}`) }}</p>
        <template v-for="(elem, idx) in fieldChangeHistory">
          <p v-if="elem.orderType === 'split'" :key="idx">
            <v-icon>mdi-call-split</v-icon>
            {{ getDateUserFormat(elem.orderDate) }} - Split {{ elem.split }}
          </p>

          <p v-if="elem.orderType === 'brokerTransfer'" :key="idx">
            <v-icon>mdi-bank-transfer</v-icon>
            {{ getDateUserFormat(elem.orderDate) }} -
            {{
              $t(
                `views.dashboardDetail.coreOrders.coreOrdersTable.changeHistory.brokerTransferFrom`
              )
            }}
            {{ `${elem.oldBrokerAlias}` }}
            {{ $t(`common.to`) }}
            {{ ` ${elem.newBrokerAlias}` }}
          </p>

          <p v-if="elem.orderType === 'sharePremium'" :key="idx" class="items-flex">
            <v-icon class="mr-1">mdi-handshake-outline</v-icon>
            {{ getDateUserFormat(elem.orderDate) }} -
            {{ $t(`views.dashboardDetail.coreOrders.coreOrdersTable.changeHistory.sharePremium`) }}
          </p>

          <p v-if="elem.orderType === 'scrip'" :key="idx" class="items-flex">
            <v-icon class="mr-1">mdi-piggy-bank-outline</v-icon>
            {{ getDateUserFormat(elem.orderDate) }} -
            {{ $t(`views.dashboardDetail.coreOrders.coreOrdersTable.changeHistory.scrip`) }}
          </p>

          <p v-if="elem.orderType === 'capitalIncrease'" :key="idx" class="items-flex">
            <v-icon class="mr-1">mdi-briefcase-upload-outline</v-icon>
            {{ getDateUserFormat(elem.orderDate) }} -
            {{
              $t(`views.dashboardDetail.coreOrders.coreOrdersTable.changeHistory.capitalIncrease`)
            }}
          </p>

          <p v-if="elem.orderType === 'spinOff'" :key="idx" class="items-flex">
            <v-icon class="mr-1">mdi-set-split</v-icon>
            {{ getDateUserFormat(elem.orderDate) }} -
            {{ $t(`views.dashboardDetail.coreOrders.coreOrdersTable.changeHistory.spinOff`) }}
          </p>
        </template>
      </div>
    </v-tooltip>
  </div>
</template>

<script>
import { getDateUserFormat } from '@/lib/utils/date.js'

export default {
  props: {
    changeHistory: {
      type: Array,
      default: () => [],
    },
    field: {
      type: String,
      required: true,
    },
    position: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    fieldChangeHistory() {
      return this.changeHistory.filter((elem) => elem.changes.indexOf(this.field) > -1)
    },
  },
  methods: {
    getDateUserFormat,
  },
}
</script>

<style lang="scss">
#order-change-history-tooltip {
  .items-flex {
    display: flex;
  }
}
</style>
